import { defineComponent } from 'vue';
import {
    VIRTUAL_RED_TAG_QUERY_TRUE,
    VirtualRedTagNotificationChannel,
    VirtualRedTagNotificationQuery,
} from '@/types/VirtualRedTagNotification';

// Shared by the three notification screens. The assessment id travels in the query
// string so a refresh keeps it; every screen must pass it on when it navigates.
export default defineComponent({
    props: {
        trailerNumber: {
            type: String,
            required: true,
        },
        assessmentId: {
            type: String,
            default: undefined,
        },
    },
    created(): void {
        // Nothing to save a preference against (a bookmarked or hand-typed URL).
        if (!this.assessmentId) {
            this.$router.replace({ name: 'VirtualRedTagEntry' });
        }
    },
    methods: {
        // Query for the next screen. Built from the props rather than spread from
        // $route.query so a stale param is never carried forward.
        notificationQuery(
            method?: VirtualRedTagNotificationChannel,
            trailerAlreadyInShop = false
        ): Record<string, string> {
            const query: Record<string, string> = {
                [VirtualRedTagNotificationQuery.assessmentId]: this
                    .assessmentId as string,
            };
            if (method) {
                query[VirtualRedTagNotificationQuery.method] = method;
            }
            if (trailerAlreadyInShop) {
                query[VirtualRedTagNotificationQuery.trailerAlreadyInShop] =
                    VIRTUAL_RED_TAG_QUERY_TRUE;
            }
            return query;
        },
        navigateToWelcome(): void {
            this.$router.push({ name: 'VirtualRedTagEntry' });
        },
    },
});
